import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    rounded: {
      borderRadius: "20px",
    },
    flexRow: {
      alignSelf: "flex-start",
      display: "flex",
      gap: "6px",
      alignItems: "center",
      margin: "4px 0",
    },
    PropertyCardWrapper: {
      alignItems: "center",
      background: theme.palette.background.paper,
      border: `1px solid ${theme.palette.border.secondary}`,
      borderRadius: "12px",
      display: "flex",
      flex: "1 0 0",
      flexDirection: "column",
      maxWidth: "339px",
      minWidth: "339px",
      width: "339px",
      overflow: "hidden",
    },
    detailsWrapper: {
      alignSelf: "flex-start",
      display: "flex",
      flexDirection: "column",
      gap: "9px",
    },
    idSection: {
      alignItems: "center",
      display: "flex",
      gap: "8px",
    },
    cardHeader: {
      display: "flex",
      justifyContent: "space-between",
      width: "100%",
      marginBottom: "18px",
    },
    divider: {
      width: "100%",
      margin: "15px 0 8px 0",
      borderBottom: `1px solid ${theme.palette.background.secondary}`,
    },
    nameContainer: {
      alignItems: "center",
      display: "flex",
      fontSize: "20px",
      gap: "6px",
    },
    dateContainer: {
      display: "flex",
      gap: "12px",
    },
    dateText: {
      display: "flex",
      gap: "8px",
    },
    wrapper: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      paddingBottom: "20px",
    },
  };
});
